module.exports = __webpack_public_path__ + "img/orange_072.fb168772.png";